import { render, staticRenderFns } from "./ekk_footer.vue?vue&type=template&id=65ec937a&scoped=true"
import script from "./ekk_footer.vue?vue&type=script&lang=js"
export * from "./ekk_footer.vue?vue&type=script&lang=js"
import style0 from "./ekk_footer.vue?vue&type=style&index=0&id=65ec937a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec937a",
  null
  
)

export default component.exports